import { ChatMessageContentType } from '@indigohive/cogfy-types'
import { GetChatMessageFilesResultData } from '@indigohive/cogfy-types/endpoints/getChatMessagesPage'
import { ClassValue } from 'clsx'
import { createElement } from 'react'
import { ChatMessageContentText } from './ChatMessageContentText'
import { ChatMessageContentAudio } from './ChatMessageContentAudio'
import { ChatMessageContentImage } from './ChatMessageContentImage'
import { ChatMessageContentDocument } from './ChatMessageContentDocument'
import { ChatMessageContentInteractive } from './ChatMessageContentInteractive'

type ChatMessageContentComponentType = typeof ChatMessageContentText

const CHAT_MESSAGE_CONTENT_BY_TYPE: Partial<Record<ChatMessageContentType, ChatMessageContentComponentType>> = {
  audio: ChatMessageContentAudio,
  document: ChatMessageContentDocument,
  image: ChatMessageContentImage,
  interactive: ChatMessageContentInteractive,
  text: ChatMessageContentText
}

export type ChatContentProps = {
  className?: ClassValue
  content: string | null
  contentType: ChatMessageContentType | null
  contentData: any
  files: GetChatMessageFilesResultData[]
  fromAuthenticatedUser: boolean
}

export function ChatMessageBubbleContent (props: ChatContentProps) {
  const { contentType } = props

  const ChatMessageContentComponent = contentType
    ? CHAT_MESSAGE_CONTENT_BY_TYPE[contentType]
    : null

  return (
    <>
      {ChatMessageContentComponent && createElement(ChatMessageContentComponent, props)}
    </>
  )
}
